const ActiveProductActions = {
    SET_ACTIVE_PRODUCT: 'SET_ACTIVE_PRODUCT',
    UNSET_ACTIVE_PRODUCT: 'UNSET_ACTIVE_PRODUCT',
};
export default ActiveProductActions;
